import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { HoldBreakdownData } from './hold-breakdown.model';

/**
 * #124: MOBILE container for a Balance-on-Hold drill-down — a bottom-sheet-styled
 * NgbModal (Figma 287:2 / 290:2). It hosts the shared
 * {@link HoldBreakdownContentComponent} and adapts its dismiss/navigate outputs
 * to the modal lifecycle. No new UI dependency: bottom-sheet look comes from the
 * `hold-breakdown-sheet` windowClass (see wallet.component.scss / styles).
 *
 * `data` is set on the component instance by the opener (WalletComponent).
 */
@Component({
  selector: 'app-hold-breakdown-sheet',
  templateUrl: './hold-breakdown-sheet.component.html',
  standalone: false,
})
export class HoldBreakdownSheetComponent {
  data: HoldBreakdownData;

  constructor(
    public modal: NgbActiveModal,
    private readonly router: Router,
  ) {}

  close(): void {
    this.modal.dismiss();
  }

  goTo(commands: any[]): void {
    if (commands?.length) {
      this.router.navigate(commands);
    }
    this.modal.dismiss();
  }
}
